const initialState = {
    data: [],
    page: 1,

    total: 0,
    alreadyMounted: false,
};

function invoicesReducer(state = initialState, action) {
    let nextState;
    switch (action.type) {
        case "SET_INVOICE_DATA":
            nextState = {
                ...state,
                data: action.value,
            };
            return nextState || state;
        case "SET_INVOICE_PAGE":
            nextState = {
                ...state,
                page: action.value,
            };
            return nextState || state;
        case "SET_INVOICE_TOTAL":
            nextState = {
                ...state,
                total: action.value,
            };
            return nextState || state;
        case "SET_INVOICE_ALREADY_MOUNTED":
            nextState = {
                ...state,
                alreadyMounted: action.value,
            };
            return nextState || state;
        default:
            return state;
    }
}

export default invoicesReducer;